/* @flow */

module.exports = {
  "LOCALE": {
    "CURRENCY": "NOK",
    "CURRENCY_SHORT": "kr",
    "POINTS": "",
  },
  "META": {
    "HELPDESK_LINK": "https://helpdesk.crossroads.se/?s=160098dfe19afa160098dfe19b34",
  },
  "SKIP_TO_CONTENT": "Gå til innhold",
  "URL": {
    "CHECKOUT_CART": "/checkout/cart",
    "CHECKOUT_OVERVIEW": "/checkout/overview",
    "CHECKOUT_SUCCESS": "/checkout/success",
    "CHECKOUT_FAILED": "/checkout/overview",
  },
  "LOGO": {
    "ALT": "Zupergift.com",
    "TITLE": "Hjem",
  },
  "CLOSE_SYSTEM_MESSAGE": "Lukk melding",
  "COOKIE_CONSENT": {
    "ALL": "Tillat alle",
    "SELECTED": "Tillat valg",
    "NECESSARY": "Tillat nødvendige",
  },
  "COOKIE_OPTIONS": {
    "NECESSARY": "Nødvendig",
    "STATISTICAL": "Statistisk",
    "MARKETING": "Markedsføring",
  },
  "ROUTES": {
    "ALL_GIFTCARDS": "/alle-gavekort",
  },
  "HOMEVIEW": {
    "POPULAR_BRANDS": "Populære varemerker ",
    "POPULAR_CATEGORIES": "Populære kategorier",
    "POPULAR_PRODUCTS": "Populære gavekort",
    "ALL_CATEGORIES": "Alle kategorier",
    "MORE_POPULAR_PRODUCTS": "Flere populære produkter",
    "TUTORIAL": "Det er slik det fungerer",
  },
  "COMPANYVIEW": {
    "HERO": {
      "TITLE": "Gavekort til bedrifter",
      "CONTENT": "Digitale gavekort som gjør firmagaver enkle. Dere velger verdi – mottakeren velger selv blant hundrevis av kjente varemerker. En fleksibel løsning som sparer tid og styrker relasjoner.",
      "LIST_ITEM_1": "Rask digital levering",
      "LIST_ITEM_2": "100+ kjente varemerker",
      "LIST_ITEM_3": "Trygg håndtering med personlig support",
    },
    "POPULAR_TITLE": "Populære varemerker du finner hos oss",
    "CTA_1": "Tilbudsforespørsel",
    "CTA_LINK_1": "https://2dd4ic.share-eu1.hsforms.com/2pymdxxYbTZe8Px8O2t20BQ",
    "CTA_2": "Kontakt oss",
    "CTA_LINK_2": "https://helpdesk.crossroads.se/?s=15e4e4fcc649e015e4e4fcc64a16",
    "FIELD_1": {
      "TITLE": "Digitale gavekort fra 100+ kjente varemerker",
      "TEXT_CONTENT": "Gi mottakeren friheten til å velge selv fra et bredt utvalg innen mote, sport, elektronikk, reiser og opplevelser. Perfekt for julegaver, bonus, insentiver og kampanjer der dere vil skape ekte motivasjon. Enkelt å sende. Liten innsats. Stor effekt.",
      "CTA": "Se utvalg",
      "CTA_LINK": "/alle-gavekort",
    },
    "FIELD_2": {
      "TITLE": "Slik fungerer firmagavene våre",
      "LIST_ITEM_1": "1. Opprett bedriftskonto",
      "LIST_ITEM_2": "2. Legg til brukere",
      "LIST_ITEM_3": "3. Be om faktura",
      "LIST_ITEM_4": "4. Kontoen fylles på",
      "LIST_ITEM_5": "5. Send ut gavekort",
      "LIST_ITEM_6": "6. Se samlet statistikk i portalen",
    },
  },
  "TUTORIAL": {
    "STEP_1": {
      "TITLE": "1",
      "TEXT": "Kjøp Zupergift",
      "LINK": "/zupergift",
    },
    "STEP_2": {
      "TITLE": "2",
      "TEXT": "Levering direkte på e-post",
    },
    "STEP_3": {
      "TITLE": "3",
      "TEXT": "Løs i Zupergift",
      "LINK": "/redeem",
    },
    "STEP_4": {
      "TITLE": "4",
      "TEXT": "Velg gavekort",
      "LINK": "/alle-gavekort",
    },
  },
  "REDEEM": {
    "HEADING": "Bruk ditt gavekort",
    "CLOSE": "Lukk",
    "TEXT": "Begynn med å oppgi din kode nedenfor, Koden finner du i meiljen som levererte ditt Zupergift-gavekort. I neste trinn velger du varemerker du ønsker å veksle gavekortet mot. Gå deretter til kassen og avlutt bestillingen, dine gavekort leveres til din e-post. Zuper-enkelt!",
    "PLACEHOLDER_CODE": "Oppgi kode",
    "PLACEHOLDER_PIN": "Oppgi pin",
    "SUBMIT": "Spare",
    "SUCCESS_ROUTE": "/alle-gavekort",
    "HOWTO": {
      "CODE": "Skriv inn verdikoden din",
      "BALANCE": "Se saldoen din",
      "SELECT": "Velg gavekort",
      "DELIVERY": "Levering via e-post",
    },
  },
  "ADDRESS": {
    "FIRSTNAME": "Fornavn",
    "LASTNAME": "Etternavn",
    "STREET_1": "Gateadresse 1",
    "STREET_2": " Gateadresse 2 (frivilligt)",
    "POSTCODE": "Postnummer",
    "CITY": "By",
    "COUNTRY": "Land",
    "EMAIL": "E-mail",
    "TELEPHONE": "Telefon",
  },
  "CAROUSEL": {
    "ITEM_LABEL": "Artikkel %current av %total",
    "CONTROLS": {
      "LABEL": "Navigasjon for karusell",
      "PREV_ITEM_GROUP_LABEL": "Forrige artikkelgruppe",
      "NEXT_ITEM_GROUP_LABEL": "Neste artikkelgruppe",
      "GO_TO_ITEM_GROUP_LABEL": "Gå til artikkelgruppe %number",
      "PLAY_LABEL": "Start automatisk avspilling",
      "PAUSE_LABEL": "Sett automatisk avspilling på pause",
    },
  },
  "DIALOGUE": {
    "CLOSE": "Lukk dialog",
  },
  "NOTIFICATIONBAR": {
    "CLOSE": "Lukk banner",
  },
  "OR": "eller",
  "CART": {
    "CLOSE": "Lukk handlekurven",
    "HEADING": "Handlekurv",
    "TOTALS": "Totalt",
    "YOUR_BALANCE": "Din saldo",
    "AFTER_PURCHASE": "Saldo etter kjøp",
    "VALID_TO": "Gyldig til",
    "PAY_VOUCHER": "Gavekort",
    "EMPTY": "Handlekurven er tom",
    "INCREMENT": "Øke antall",
    "DECREMENT": "Minsk antall",
    "QUANTITY": "Antall",
    "NAV_BUTTON": "Gå til handlekurven, det finnes %amount produkt(er))",
    "CTA": "Gå til handlekurven",
    "PRODUCTS": "Produkter",
    "SHIPPING": "Frakt",
    "SUMMARY": "Summering",
    "TO_CHECKOUT": "Gå til kassen",
    "DIALOG_CANCEL": "Avbryt",
    "REMOVE_PRODUCT": "Fjern produkt",
    "REMOVE_APPROVE": "Ja, fjern",
    "CONFIRM_TEXT": "Vil du virkelig fjerne '%itemName' fra handlekurven?",
    "CONTINUE_SHOPPING": "Fortsett handle",
    "DISCOUNT": "Rabatt",
    "SUB_TOTAL": "Beløp",
    "GRAND_TOTAL": "Totalt",
    "CLOSE_SUMMARY": "Lukk oversikten",
    "OPEN_SUMMARY": "Åpne oversikten",
    "SUBMIT": "Lagre antall produkter",
  },
  "CHECKOUT": {
    "TITLE": "Kasse",
    "CONTINUE": "Fortsett",
    "TO_PAYMENT": "Gå til betaling",
    "AMOUNT_TO_PAY": "Å betale",
    "EDIT": "Endre",
    "BACK_TO_CART_TEXT": "Tilbake til handlekurven",
    "COMPLETE_PURCHASE": "Fullfør kjøp",
    "REDEEM_LABEL_CODE": "Gavekortkode",
    "REDEEM_LABEL_PIN": "Oppgi tilhørende pinkoden",
    "REDEEM_SUBMIT": "Brukt",
    "OPT_EMAIL": "Jeg ønsker informasjon om tilbud fra Zupergift",
    "I_ACCEPT_THE": "Jeg aksepterer",
    "TERMS": "kjøpsvilkårene",
    "TERMS_URL": "vilkar",
    "TERMS_CLOSE": "Lukk vilkar",
    "PAYMENT_METHOD_STEP": "Velg betalingsmetode",
    "PAY_STEP": "Gå til sikker betaling",
    "ADDRESS": {
      "ADDRESS": "Faktura og leveringsinformasjon",
      "SHIPPING": "Leveranseadresse",
      "SHIP_TO_SAME_ADDRESS": "Leveres til samme adresse",
    },
    "DISCOUNT_CODE": {
      "HEADER": "Rabattkode",
      "PLACEHOLDER": "Skriv inn kode",
      "APPLY": "Anvend",
      "REMOVE": "Ta vekk",
    },
  },
  "PAYMENT_METHODS": {
    "ALTAPAY": {
      "CARD": "Betal med kort",
    },
  },
  "SUCCESS": {
    "TITLE": "Bestillingen er registrert",
    "SUB_TITLE": "Ordrenummer %number",
    "BACK": "Fortsett å handle",
    "NOT_FOUND_TITLE": "Ingen ordre funnet.",
    "NOT_FOUND_SUBTITLE": "Ta kontakt med kundeservice hvis dette er feil.",
    "WHAT_NOW": "Så hva skjer nå?",
    "STEPS": {
      "HEADING": " Bestillingen er registrert ",
      "WHAT_NOW": " Så hva skjer nå?",
      "LABEL": "Din bestilling",
      "ORDER_ID": "Ordrenummer %id",
      "QUESTIONS": {
        "HEADING": "Har du et spørsmål om din bestilling?",
        "LABEL": "Gå til kundeservice",
        "URL": "/faq",
      },
      "NORMAL": {
        "1": {
          "HEADING": "Bekreftelse",
          "TEXT": "En ordrebekreftelse sendes til %email innen kort.",
        },
        "2": {
          "HEADING": "Bearbeider",
          "TEXT": "Din bestilling blir sendt når alle produktene er på lager. Dette skjer normalt nestkommende dag.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "När dina varor packats och skickats så meddelas du via e post. I leveransbekräftelsen finner du en spårningslänk med vilken du kan följa paketets väg. Leveransen tar normalt 1–2 dagar.",
        },
        "4": {
          "HEADING": "Leveranse",
          "TEXT": "Vissa paket levereras direkt i din brevlåda. Paket som är för stora levereras i stället till ett utlämningsställe och aviseras via sms till det mobilnummer du har angivit i beställningen. Paket ligger kvar på utlämningsstället i 14 dagar.",
        },
      },
      "MIXED": {
        "1": {
          "HEADING": "Bekräftelse",
          "TEXT": "En orderbekräftelse och dina digitala biljetter/värdekoder kommer att skickas till %email inom kort. Har du inte fått någon e post ber vi dig dubbelkolla ditt spam-filter innan du kontaktar kundservice.",
        },
        "2": {
          "HEADING": "Bearbetning",
          "TEXT": "Din beställning skickas när samtliga produkter finns tillgängliga för leverans. Vanligen sker detta redan nästkommande dag.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "När dina varor packats och skickats så meddelas du via e post. I leveransbekräftelsen finner du en spårningslänk med vilken du kan följa paketets väg. Leveransen tar normalt 1–2 dagar.",
        },
        "4": {
          "HEADING": "Leverans",
          "TEXT": "Vi skickar dina digitala biljetter/värdekoder till %email inom kort. Din fysiska leverans skickas med DBSchenker. Vissa paket levereras direkt i din brevlåda. Paket som är för stora levereras i stället till ett utlämningsställe och aviseras via sms till det mobilnummer du har angivit i beställningen. Paket ligger kvar på utlämningsstället i 14 dagar.",
        },
      },
      "VIRTUAL": {
        "1": {
          "HEADING": "Bekreftelse",
          "TEXT": "Du får en ordrebekreftelse til %email.",
        },
        "2": {
          "HEADING": "Digital leveranse",
          "TEXT": "Vi sender dine digitale verdikoder %email innen kort. Har du ikke mottatt noen e-post ber vi deg dobbeltsjekke spamfiltret før du kontakter kundeservice.",
        },
      },
    },
    "CONTACT": {
      "TITLE": "Lurer du på noe?",
      "INFO": "Vi svarer på dine spørsmål om leveranser og produkter 48 timer på hverdager.",
      "CREATE_TICKET": "Skriv til oss via kontaktskjemaet",
    },
  },
  "CATEGORY": {
    "EMPTY": "Det finns ingenting å vise akkurat nå",
    "LOAD_MORE": "Lade flere",
    "PRODUCTS_IN_CATEGORY_TITLE": "Viser %itemsCount produkter i",
    "PRODUCTS_IN_CATEGORY_TITLE_SINGULAR": "Viser 1 produkt i",
    "PRODUCTS_IN_CATEGORY_TITLE_PLURAL": "Viser %itemsCount produkter i",
    "PRODUCTS_IN_CATEGORY_TITLE_EMPTY": "Viser produkter i",
  },
  "ALL_GIFTCARDS": {
    "TITLE": "Alle gavekort",
  },
  "404": {
    "TITLE": "Siden kunne ikke finnes",
    "HEADING": "— 404 —",
    "SUBHEADING": "Siden kunne ikke finnes",
  },
  "SERVER_ERROR": {
    "TITLE": "Serverfeil",
    "TEXT": "<strong>Vil du komme i kontakt med oss?</strong><br/> Send en mail til <a href=\"mailto:kundservice@crossroads.se\">kundservice@crossroads.se</a>",
  },
  "SEARCH": {
    "TITLE_PREFIX": "Søk: ",
    "PLACEHOLDER": "Søk etter gavekort",
    "PRODUCTS_IN_SEARCH_RESULT": "Fant %itemsCount produkter som passet",
    "PRODUCT_IN_SEARCH_RESULT": "Fant én produkt som passet",
  },
  "FILTER": {
    "FILTERBAR": {
      "ALL_FILTERS": "Alle filter",
      "FILTER_BY_POINTS": "Filtrere på poeng",
      "FILTER_BY_PRICE": "Filtrere på pris",
      "PRICE_RANGE": "%min - %max kr",
      "SORT": "Sortera",
      "SORT_PRICE_DESC": "Pris ↓",
      "SORT_PRICE_ASC": "Pris ↑",
      "SORT_NAME_DESC": "Navn ↓",
      "SORT_NAME_ASC": "Navn  ↑",
    },
    "OFFCANVAS": {
      "TITLE": "Filter",
      "SHOW_RESULT_TOTAL_SINGLE": "%total Produkt",
      "SHOW_RESULT_TOTAL_MULTIPLE": "%total Produkter",
      "SHOW_RESULT": "Se resultat",
      "CLOSE_MENU": "Lukk filter",
    },
    "ACTIVE_FILTERS": {
      "CLEAR_ALL": "Fjern filter",
      "NO_ACTIVE_FILTERS": "Du har ingen aktive filter",
      "PRICE_RANGE": "Pris (%range)",
    },
    "FILTERMENU": {
      "FILTER_BY_PRICE": "Filtrere på poeng",
      "FILTER_BY_POINTS": "Filtrere på pris",
      "RESET_PRICE": "Rense filter",
      "PRICE_FROM": "Fra",
      "PRICE_TO": "Til",
    },
  },
  "HEADER": {
    "MAIN_NAVIGATION": "Hovedmeny",
    "OPEN_MENU": "Åpne menyen",
    "CLOSE_MENU": "Lukk menyen",
    "BACK": "Gå tilbake",
    "SEARCH": "Søk",
    "OPEN_SEARCH": "Åpne søk",
    "CLOSE_SEARCH": "Lukk søk",
    "ALL_GIFTCARDS": "Alle gavekort",
    "BUY_ZUPERGIFT": "Kjøp Zupergift",
    "REDEEM_GIFTCARD": "Bruk Zupergift",
    "CATEGORIES": "Kategorier",
    "COMPANY": "Forretninger",
    "CART": "Handlekurv",
    "HELP": "Kontakt",
    "ABOUT": "Hvordan fungerer det?",
    "CLOSE_CATEGORIES": "Lukk kategorier",
  },
  "FOOTER": {
    "NAVIGATION": "Bunntekstmeny",
    "CATEGORIES": "Kategorier",
    "COPYRIGHT": "Copyright © %currentYear",
    "RECAPTCHA": "This site is protected by reCAPTCHA and the Google <a href=\"https://policies.google.com/privacy\">Privacy Policy</a> and <a href=\"https://policies.google.com/terms\">Terms of Service</a> apply.",
    "LANGUAGE_SWITCHER_TEXT": "You're using the Norwegian version of Zupergift",
    "LANGUAGE_SWITCHER_BUTTON": "Change language/region",
    "COOKIES": "Administrer cookies",
    "TERMS_LINK": "vilkar",
    "TERMS_TEXT": "Kjøpsvilkår",
    "ACCESSIBILITY": "Tilgjengelighet",
  },
  "LANGUAGE_SWITCHER": {
    "TITLE": "Welcome!",
    "CLOSE": "Close language switcher",
    "SUB_TITLE": "You're using the Norwegian version of Zupergift. Do you want to change language/region?",
    "FINLAND": "Finland",
    "DENMARK": "Denmark",
    "NORWAY": "Norway",
    "SWEDEN": "Sweden",
  },
  "BREADCRUMBS": {
    "HOME_URL": "/",
    "HOME": "Hjem",
    "SEARCH_RESULTS_FOR": "Søkeresultat for: ",
  },
  "PRODUCT": {
    "STARTING_AT": "Fra",
    "ADD_TO_CART": "Legg i handlekurv",
    "OUT_OF_STOCK": "Slut på lager",
    "DESCRIPTION": "Produktbeskrivelse",
    "RELATED_PRODUCTS": "Relaterte produkter",
    "CROSS_SELL_PRODUCTS": "Andre likte også",
    "OPTION_PLACEHOLDER": "Velg %attributeLabel",
    "OPTION_DROPDOWN_PLACEHOLDER": "Velg et alternativ...",
    "CHANGE_IMAGE": "Bytt bilde",
  },
  "VALIDATION": {
    "REQUIRED": "Obligatorisk felt",
    "EMAIL": "Vennligst oppgi korrekt e postadresse",
    "PHONE": " Vennligst oppgi korrekt mobiltelefonnummer",
    "NUMERIC": "Feltet kan kun inneholde nummer",
    "LENGTH_LT": "Feltet inneholder for mange tegn",
    "POSTCODE": "Vennligst oppgi korrekt postnummer (XXX XX)",
    "MATCH": "Informasjonen stemmer ikke overens",
    "MISSING_FIELD": "Mangler adresse. Prøv igjen",
  },
  "STATUS_CODE": {
    /* Client */
    "UNKNOWN": "En ukjent feil har. Vennligst lad siden på nytt.",
    "NETWORK_ERROR": "Anropet ble avbrutt. Vennligst verifiser at du har en aktiv internettoppkobling.",
    "PLACE_ORDER_CATCH": "En feil oppsto, vennligst prøv igjen Vennligst prøv igjen.",
    "AQUIRER_DECLINE": "Betalingen har blitt avvist. Vennligst bekreft kort-/kontoopplysningene dine.",

    "errorFraudShop": "Det er ikke mulig å fullføre et kjøp på dette tidspunktet.",
    "errorFraudOrder": "Kjøpet er ikke tillatt. Kontakt support for mer informasjon.",
    "errorFraudProduct": "Grensen er nådd for ett eller flere produkter i handlekurven. Kontakt support for mer informasjon.",
    "errorFraudBlacklist": "Kjøpet er ikke tillatt. Kontakt support for mer informasjon.",
    "errorDeclinedCard": "Kortet ble avvist.",

    "errorProductQuantityNotAvailable": "Det antallet du oppgav er ikke tilgjengelig akkurat nå.",
    "errorProductNotInStock": "Produktet du prøvde å legge i handlekurven er dessverre ikke på lager akkurat nå.",
    "errorProductMaxQuantity": "Det ønskede antallet er dessverre ikke på lager akkurat nå.",
    "errorProductNotChosenVariant": "Vennligst velg %attributeLabel for å legge produktet i handlekurven.",
    "errorBillingAddressValidationFailed": "Feil adresse",
    "errorInvalidTelephone": "Ugyldig telefonnummerformat.",
    "REDEEM_ERROR": {
      "_777": "Gavekortskoden er ikke gyldig. Kontroller koden og prøv igjen.",
      "_786": "Ukjent feil, kontroller koden og prøv igjen.",
      "_800": "Koden er allerede brukt",
      "_791": "Gavekortskoden krever pinkode. Vennligst oppgi tilhørende pinkode og prøv igjen.",
      "_792": "Pinkoden er ikke gyldig. Kontrollere pinkoden og prøv igjen.",
    },
    "success": "Gavekortskoden er aktivert!",
    "DISCOUNT_CODE_FAILURE": "Rabattkoden kunne ikke brukes, prøv igjen eller kontakt kundeservice.",
    "DISCOUNT_CODE_APPLIED": "Rabattkode brukt.",
  },
  "ICONS": {
    "ARROW": "Pil høyre",
    "CHEVRON": "Pil",
    "CART": "Handlevogn",
    "HEADPHONES": "Hodetelefoner",
    "MAGNIFIER": "Forstørrelsesglass",
    "CROSS": "Kryss",
    "HAMBURGER": "Tre horisontale linjer (hamburgerikon)",
    "AVATAR": "Avatar",
    "DENMARK_FLAG": "Danmarks flagg",
    "FINLAND_FLAG": "Finlands flagg",
    "SWEDEN_FLAG": "Sveriges flagg",
    "NORWAY_FLAG": "Norges flagg",
  },
};
